import { render, staticRenderFns } from "./service-costs-explanation.vue?vue&type=template&id=34abb026&"
import script from "./service-costs-explanation.vue?vue&type=script&lang=ts&"
export * from "./service-costs-explanation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports